import { createSelector } from 'reselect';

export const selectInstruments = (s) => s.instruments.items;
const selectPerformances = (s) => s.instruments.performances;
export const selectInstrumentsIntervalKpis = (s) => s.instruments.intervalKpis;
export const selectLatestInstruments = (s) => s.instruments.latest;

export const selectInstrument = createSelector(
  (_, id) => id,
  selectInstruments,
  selectPerformances,
  (id, instruments, performances, kpis) => {
    if (instruments[id]) {
      return {
        ...instruments[id],
        ...performances[id],
      };
    }
    return undefined;
  }
);

export const selectInstrumentIntervalKpis = createSelector(
  (_, id) => id,
  selectInstruments,
  selectInstrumentsIntervalKpis,
  (id, instruments, intervalKpis) => {
    if (instruments[id]) {
      return {
        ...instruments[id],
        ...intervalKpis[id],
      };
    }
    return undefined;
  }
);
